/* import __COLOCATED_TEMPLATE__ from './conversation-assignment-changed.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();